import { domain } from 'modules/data';
import { useCallback } from 'react';
import { useToggle } from 'react-use';
import { useGetNetSuiteBillMatching, useGetNetSuitePurchaseOrderMatching } from 'shared/data/webApp/v2';

export const useNetSuiteMatchingInfo = (
    requestId: string,
    companyId: string,
    integrationCode: domain.IntegrationCode,
    isEnabled: boolean
) => {
    const { data: netSuiteBillMatching, isFetching: isNetSuiteBillMatchingFetching } = useGetNetSuiteBillMatching(
        {
            path: {
                companyId,
                vendorBillRequestId: requestId,
            },
        },
        { enabled: isEnabled && integrationCode === domain.IntegrationCode.NetSuiteBill }
    );

    const { data: netSuitePurchaseOrderMatching, isFetching: isNetSuitePurchaseOrderMatchingFetching } =
        useGetNetSuitePurchaseOrderMatching(
            {
                path: {
                    companyId,
                    purchaseOrdersRequestId: requestId,
                },
            },
            { enabled: isEnabled && integrationCode === domain.IntegrationCode.NetSuitePO }
        );

    return {
        matchingInfo: netSuiteBillMatching || netSuitePurchaseOrderMatching,
        isFetching: isNetSuiteBillMatchingFetching || isNetSuitePurchaseOrderMatchingFetching,
    };
};

export const useNetSuiteMatchingInfoDropdown = (isOpenedDefault: boolean = false) => {
    const [isOpened, toggleIsOpened] = useToggle(isOpenedDefault);

    const onDropdownClose = useCallback(() => toggleIsOpened(false), [toggleIsOpened]);

    return {
        isOpened,
        onDropdownClose,
        toggleIsOpened,
    };
};
